import React from 'react';

import {Text} from '../../Text';

import {SearchableListLabelView} from './SearchableListBox.styles';
import {visuallyHiddenStyles} from '../../VisuallyHidden';

export const SearchableListLabel = React.forwardRef<
  HTMLDivElement,
  {
    children: React.ReactNode;
    id: string;
    isVisuallyHidden?: boolean;
  }
>(({children, id, isVisuallyHidden = false}, ref) => {
  return (
    <SearchableListLabelView
      ref={ref}
      style={isVisuallyHidden ? visuallyHiddenStyles : undefined}
    >
      <Text
        colorVariant="primary"
        font="heading"
        id={id}
        role="presentation"
        userSelect="none"
      >
        {children}
      </Text>
    </SearchableListLabelView>
  );
});
